module.exports = __webpack_public_path__ + "img/fi-rr-paper-plane.de0254e3.svg";